var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIntoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 13.1665C4.37658 13.1665 1.83366 10.6236 1.83366 7.49984C1.83366 4.37609 4.37658 1.83317 7.50033 1.83317C10.6241 1.83317 13.167 4.37609 13.167 7.49984C13.167 10.6236 10.6241 13.1665 7.50033 13.1665ZM7.50033 0.416504C6.57013 0.416504 5.64904 0.59972 4.78965 0.955691C3.93026 1.31166 3.1494 1.83342 2.49165 2.49116C1.16327 3.81955 0.416992 5.62122 0.416992 7.49984C0.416992 9.37845 1.16327 11.1801 2.49165 12.5085C3.1494 13.1663 3.93026 13.688 4.78965 14.044C5.64904 14.4 6.57013 14.5832 7.50033 14.5832C9.37894 14.5832 11.1806 13.8369 12.509 12.5085C13.8374 11.1801 14.5837 9.37845 14.5837 7.49984C14.5837 6.56964 14.4004 5.64855 14.0445 4.78916C13.6885 3.92977 13.1667 3.14891 12.509 2.49116C11.8512 1.83342 11.0704 1.31166 10.211 0.955691C9.35161 0.59972 8.43052 0.416504 7.50033 0.416504ZM8.20866 3.95817H6.79199V6.7915H3.95866V8.20817H6.79199V11.0415H8.20866V8.20817H11.042V6.7915H8.20866V3.95817Z",
    fill: "#7CBE7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIntoCircle);
export default __webpack_public_path__ + "static/media/plus-into-circle.68898fcf5ddde6070162afd5b77da18b.svg";
export { ForwardRef as ReactComponent };